import { React, RefObject } from "react";
import {
  Form,
  Input,
  Button,
  Dialog,
  TextArea,
  Selector,
  Slider,
  Stepper,
  Switch,
} from "antd-mobile";
import styles from "./Edit.module.css"
import EditFilter from "./EditFilter.js"

const states = require("../../../utils/states.js")


const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5
}


//props.submit(gramma)  gramma 为null则取消,gramma为非null则提交
export default (props) => {
  const onFinish = (values) => {
    if (!values.level) values.level = 1
    const gramma = values
    states.grammasWrap.cur_edit_gramma = { ...values }
    console.warn('提交的gramma = ', gramma, 'order ', props.order)
    props.submit(gramma, props.order)
  }

  const onCanceled = () => {
    props.submit(null)
  }


  return (<div className={styles.addGramma}>

    <Form mode='card' className={styles.addForm}
      initialValues={{
        id: props.gramma.id,
        left_col: props.gramma.left_col || '',
        gramma: props.gramma.gramma,
        right_col: props.gramma.right_col || '',
        definition: props.gramma.definition || '',
        note: props.gramma.note || '',
        level: props.gramma.level
      }}
      onFinish={onFinish}
      layout='horizontal'
      footer={<div style={{ display: 'flex' }}>
        <Button style={{ 'flex': 1, 'marginRight': '5px' }} size='large' onClick={onCanceled}>
          取消</Button>
        <Button style={{ 'flex': 1, 'marginLeft': '5px' }}
          type='submit' color='primary' size='large'>
          提交</Button>
      </div>
      }
    >
      <div className={styles.formList}>
        <Form.Header>添加一条Gramma</Form.Header>
        <Form.Item name='id' label='修改gramma'>
        </Form.Item>
        <Form.Item name='left_col' label='左侧'>
          <Input placeholder='左侧接续' />
        </Form.Item>
        <Form.Item name='gramma' label='语法'
          rules={[{ required: true, message: '语法不能为空' }]}>
          <Input placeholder='核心语法' />
        </Form.Item>
        <Form.Item name='right_col' label='右侧'>
          <Input placeholder='右侧接续' />
        </Form.Item>
        <Form.Item name='definition' label='解释'>
          <TextArea
            placeholder='请输入解释'
            maxLength={50} rows={2} showCount />
        </Form.Item>
        <Form.Item name='note' label='笔记'>
          <TextArea
            placeholder='笔记区域'
            maxLength={100} rows={2} showCount />
        </Form.Item>
        <Form.Item name='level' label='等级'>
          <Slider style={{ '--fill-color': 'var(--adm-color-default)' }} marks={marks} ticks step={1} min={1} max={5} popover />
        </Form.Item>

        <div name='root' label='词根' style={{ padding: '15px' }}>
          词根
          <EditFilter listShell={states.rootTagsWrap} formerList={props.gramma.roots} />
        </div>
        <div name='prep' label='介词' style={{ padding: '15px' }}>
          介词
          <EditFilter listShell={states.prepTagsWrap} formerList={props.gramma.preps} />
        </div>
        <div name='form' label='语态' style={{ padding: '15px' }}>
          语态
          <EditFilter listShell={states.formTagsWrap} formerList={props.gramma.forms} />
        </div>
      </div>
    </Form>

  </div>)
}